import React, { Component } from 'react'
import { connect } from 'react-redux'
import { makeRecurringUpdate } from '../../../actions/recurringActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _RECURRING_BILLING } from '../../../actions/types'
import RecurringUpdateSample from '../samples/RecurringUpdateSample'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const OBJECT = [ "recurUpdate", "recurUpdate", "recurUpdate"]
const METHODS = {   
    order_id: [ ".setCustId(cust_id);", ".setCustId(cust_id);", "'cust_id'=>$cust_id"],
    credit_card_number: [ ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    expiry_day: [ ".setExpdate(expiry_date);", ".setExpdate(expiry_date);", "'expdate'=>$expiry_date"],
    recur_amount: [ ".SetRecurAmount(recur_amount);", ".SetRecurAmount(recur_amount);", "'recur_amount'=>$recur_ amount"],
    add_num: [ ".SetAddNumRecurs(add_num);", ".SetAddNumRecurs(add_num);", "'add_num_recurs'=> $add_num"],
    total_num: [ ".setTotalNumRecurs(total_num);", ".setTotalNumRecurs(total_num);", "'total_num_recurs'=> $total_num"],
    terminate: [ ".SetTerminate(terminate);", ".SetTerminate(terminate);", "'terminate' =>$terminate"],
    hold: [ ".setHold(hold);", ".setHold(hold);", "'hold' => $hold"],
    data_key: [ ".SetData(data_key);", ".setData(data_key);", "'data_key'=>$data_key"],
    notification_URL: [ ".SetNotificationURL(\"HTTPS://YOURURL.COM\");", ".setNotificationURL(\"HTTPS://YOURURL.COM\");", "->setNotificationURL(\"HTTPS://YOURURL.COM\");"],
}


export class RecurringUpdate extends Component {
    state = {
        showError:false,
        showSuccess:false,
        justClicked:false,
      };

    renderMessage() {
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#ffcccc', color:'#cc0000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}><strong>Error!</strong><br />Please check your parameters within recurring update.</div>
            );
        }
        // else if(this.state.showSuccess) {
        //     return (
        //         <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}><strong>Recurring Update Accepted!</strong><br />The returned receipt has been inserted to the JSON on the right, you can move to the next step now.</div>
        //     );
        // }
    }
    
    componentDidUpdate() {
        const { updateSuccess,updateResponse,loading } = this.props; 
        if(updateResponse !=="No request has been made."  && this.state.justClicked){
            if(updateSuccess){
                    this.setState({ showError: false,showSuccess: true, justClicked:false });  
                }
            else {
                if(!loading){
                    this.setState({  showError: true, showSuccess: false, justClicked:false });
                }
            }
        }
    }


    async onMakeUpdatePress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _RECURRING_BILLING, orderId: newOrderId });
        const { storeId, apiToken, order_id, pan, expdate, amount } = this.props;
        const updateRequest = { storeId, apiToken, order_id, pan, expdate, amount };
        this.props.makeRecurringUpdate(updateRequest);
        this.setState({justClicked:true});
    }

    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }
    

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample Update</h3>
                <RecurringUpdateSample />
                <div className="requestButton" onClick={() => this.onMakeUpdatePress()}>
                    Update Request
                </div>
                {this.renderMessage()} 
            </div>
        );
    }
    
    renderDocument() {
        const { progLangId } = this.props;
        return (
            <div className="stepPageContainer">  
            <div>
            <h3 className="stepPageTitle">Recurring Billing Update</h3>
            <p>After you have set up a Recurring Billing transaction series, you can change some of the details of the
                series as long as it has not yet completed the preset recurring duration (i.e., it hasn’t terminated yet).
                Before sending a Recurring Billing Update transaction that updates the credit card number, you must
                send a Card Verification request. This requirement does not apply if you are only updating the schedule
                or amount.
            </p>
            <div className="thingsToConsider">
                <p>
                    <strong>Things to Consider:<br/></strong> 
                    When completing the update recurring billing portion please keep in mind that the
                    recur bill dates cannot be changed to have an end date greater than 10 years from    
                </p>
            </div>
            <p><b>Recurring Billing Update transaction object definition</b></p> 

            
            {(() => {
                    switch(progLangId) {
                        case _DOTNET:
                            return <code>RecurUpdate recurUpdate = new RecurUpdate();</code>
                        case _JAVA:
                            return <code>RecurUpdate recurUpdate = new RecurUpdate();</code>
                        case _PHP:
                            return <code>{`$txnArray=array('type'=>'recur_update',... );`}</code>
                        default:
                            return null
                        }
                    })()}
            <p><b>HttpsPostRequest object for Recurring Billing Update transaction</b></p>   
            {(() => {
                    switch(progLangId) {
                        case _DOTNET:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();</code>
                        case _JAVA:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();</code>
                        case _PHP:
                            return <code>{`$mpgTxn = new mpgTransaction($txnArray);`}</code>
                        default:
                            return null
                        }
                    })()}

            
            
            <br/>
          
            {(() => {
                    switch(progLangId) {
                        case _DOTNET:
                            return <code>  mpgReq.SetTransaction(recurUpdate);</code>
                        case _JAVA:
                            return <code>mpgReq.setTransaction(recurUpdate);</code>
                        case _PHP:
                            return <code>
                                {`$mpgRequest = new mpgRequest($mpgTxn);`}
                                </code>
                        default:
                            return null
                        }
                    })()}
            
           

        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Recurring Billing Update transaction values</h3><br/>
        
        <h3 className="stepPageTitle" style={{ marginLeft:"20vw",fontSize:"1vw"}}>Table 1 Recurring Billing Update – Basic Required Fields</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
                <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type</th>
                    <th>Description</th>
                </tr>
                <tr>
                    <td>Order ID<br />order_id</td>
                    <td>String<br/>50-character alphanumeric</td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.order_id[progLangId]}</code></td>
                </tr>
                </tbody>
            </table>



        <h3 className="stepPageTitle" style={{ marginLeft:"20vw",fontSize:"1vw"}}>Table 2 Recurring Billing Update – Basic Optional Fields</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type</th>
                    <th>Description</th>
                </tr>
                <tr>
                    <td>Customer ID<br/>cust_id</td>
                    <td>String<br/>50-character alphanumeric</td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.order_id[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>Credit card number<br />pan</td>
                    <td>String<br/>20-character alphanumeric</td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.credit_card_number[progLangId]}</code></td>

                </tr>
                <tr>
                    <td>Expiry date<br />expiry_date</td>
                    <td>String<br/>YYMM</td> 
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.expiry_day[progLangId]}</code></td>
                </tr>   
                </tbody>
            </table>

        <h3 className="stepPageTitle" style={{ marginLeft:"20vw",fontSize:"1vw"}}>Table 3 Recurring Billing Update – Recurring Billing Required Fields</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                    <th>Description</th>
                </tr>
                <tr>
                    <td>Recurring amount<br/>recur_amount</td>
                    <td>String<br/>
                        10-character decimal; Up
                        to 7 digits (dollars) +
                        decimal point + 2 digits
                        (cents) after the decimal
                        point<br/>
                            <p className="note">
                                <strong>EXAMPLE:</strong> 
                                1234567.89      
                            </p>
                    </td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.recur_amount[progLangId]}</code></td>
                    <td>Changes the
                        amount that is
                        billed recurrently<br/>
                        The change takes
                        effect on the next
                        charge
                    </td>
                </tr>

                
                <tr>
                    <td>Add number of recurs<br/>add_num</td>
                    <td>String<br/>
                        numeric, 1-999
                    </td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.add_num[progLangId]}</code></td>
                    <td>Adds to the given
                        number of recurring
                        transactions
                        to the current
                        (remaining) number<br/>
                        This can be used
                        if a customer
                        decides to extend
                        a membership or
                        subscription<br/>Cannot be used to
                        decrease the current
                        number of
                        recurring transactions;
                        use
                        Change number
                        of recurs instead
                    </td>
                </tr>


                <tr>
                    <td>Change number of recurs<br/>total_num</td>
                    <td>String<br/>
                        numeric, 1-999
                    </td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.total_num[progLangId]}</code></td>
                    <td>Replaces the current
                        (remaining)
                        number of recurring
                        transactions
                    </td>
                </tr>
  
                <tr>
                    <td>Hold recurring billing<br/>hold</td>
                    <td>String<br/>
                        true/false
                    </td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.hold[progLangId]}</code></td>
                    <td>Temporarily
                        pauses recurring
                        billing<br/>
                        While a transaction
                        is on hold,
                        it is not billed for
                        the recurring
                        amount; however,
                        the number
                        of remaining
                        recurs continues to be decremented
                        during
                        that time
                    </td>
                </tr>


                
                <tr>
                    <td>Terminate recurring transaction<br/>
                        terminate
                    </td>
                    <td>String<br/>
                        true/false
                    </td>
                    <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.terminate[progLangId]}</code></td>

                    {/* <td><code>recurUpdate.SetTerminate(terminate);</code></td> */}
                    <td>Terminates recurring billing<br/>
                            <p className="note">
                                <strong>NOTE::: </strong> 
                                After
                                it has been
                                terminated,
                                a recurring
                                transaction
                                cannot be
                                reactivated;
                                a new purchase
                                transaction
                                with
                                recurring
                                billing must
                                be submitted.
                            </p>
                    </td>
                </tr>
                </tbody>
            </table>



            
          </div>
        </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}


const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { updateSuccess,updateResponse ,loading} = state.recurring.main;
    const { storeId, apiToken, order_id, pan, expdate, amount} = state.recurring.main.config;
    return { mode, storeId, apiToken, order_id, pan, expdate, amount, progLangId: state.common.progLangList.selection,updateResponse,updateSuccess,loading };
  }

  export default connect(mapStateToProps, {makeRecurringUpdate, updateOrderId})(RecurringUpdate)
